export const namespaced = true;
import api from "../api/api";

const baseURI = "/users/";

export const state = {
  currentUser: null,
  loading: false,
};

export const mutations = {

  SET_CURRENT_USER(state, user) {
    state.currentUser = user;
  },
  TOGGLE_LOADING(state) {
    state.loading = !state.loading;
  },
};

export const actions = {
  async fetchUser({ commit }) {
    let url = baseURI + `self/`;
    const token = localStorage.getItem("access");
    if (token) {
      api.defaults.headers.Authorization = `Bearer ${token}`;
      try {
        commit("TOGGLE_LOADING");
        const response = await api.get(url);
        commit("SET_CURRENT_USER", response.data);
      } catch (e) {
        console.log(e);
      } finally {
        commit("TOGGLE_LOADING");
      }
    }
  },
  setUser(context, user = null) {
    context.commit("SET_CURRENT_USER", user);
  },
  toggleLoading({commit}) {
    commit("TOGGLE_LOADING");
  },
};

export const getters = {
  getAccessibleProject(state) {
    return state.currentUser?.accessible_project
  }
};
